// Anlık (timestamp) değerlerin tek biçimleyicisi (F22). Her çağrı yeri
// `intlLocale` üstünden geçer; hiçbir sayfa `toLocaleDateString`'i elle yazmaz.
// Takvim GÜNÜ anlamına gelen değerler (kohort sınırları) bunu değil
// `lib/calendarDay.formatCalendarDay`'i kullanır (saat dilimi kaymasın diye).
import { intlLocale } from "@/i18n/config";

export type DateStyle = "short" | "medium" | "long" | "weekday";

const STYLES: Record<DateStyle, Intl.DateTimeFormatOptions> = {
  // "18 Sep"
  short: { day: "numeric", month: "short" },
  // "18 Sep 2026"
  medium: { day: "numeric", month: "short", year: "numeric" },
  // "18 September 2026"
  long: { day: "numeric", month: "long", year: "numeric" },
  // "Friday, 18 September 2026"
  weekday: { weekday: "long", day: "numeric", month: "long", year: "numeric" },
};

function parse(value: string | number | Date | null | undefined): Date | null {
  if (value === null || value === undefined || value === "") return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatDate(
  value: string | number | Date | null | undefined,
  locale: string,
  style: DateStyle = "long",
  fallback = "",
): string {
  const d = parse(value);
  if (!d) return fallback;
  return d.toLocaleDateString(intlLocale(locale), STYLES[style]);
}

// Tarih + saat, kısa: "18 Sep 2026, 14:05".
export function formatDateTime(
  value: string | number | Date | null | undefined,
  locale: string,
  fallback = "",
): string {
  const d = parse(value);
  if (!d) return fallback;
  return d.toLocaleString(intlLocale(locale), {
    day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
}
